import { render, staticRenderFns } from "./referalWidthDraw.vue?vue&type=template&id=15c7d5c5&"
import script from "./referalWidthDraw.vue?vue&type=script&lang=js&"
export * from "./referalWidthDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports